/**
 * Navigation
 * ---
 * Transforms a TabBar into a side navigation on certain mediaQuery.
 */

import { useLocation, useNavigate } from 'react-router-dom'
import { useMediaQuery } from 'usehooks-ts'

import { breakpoints } from '@/config/layout'
import { MobileNavigation } from './MobileNavigation'
import { WebNavigation } from './WebNavigation'

import type { NavigationProps } from './Navigation.types'
import type { WebNavigationItem } from './WebNavigation'

const Navigation = ({ items }: NavigationProps) => {
  const isMobile = useMediaQuery(breakpoints.toS)
  const location = useLocation()
  const navigate = useNavigate()

  const appVersionString = typeof APP_VERSION === 'undefined' ? undefined : APP_VERSION

  if (isMobile) {
    const mobileItems = items
      .filter((item) => item.label !== 'Profiel')
      .map((item) => {
        const href = item.href.toString()
        // Check if pathname matches exactly or ends with the href (for tenant prefixes like /azmm or /olvw)
        const isActive = location.pathname === href || location.pathname.endsWith(href)

        return {
          ...item,
          href,
          isActive,
          id: href,
          onClick: () => navigate(href),
        }
      })

    return <MobileNavigation items={mobileItems} />
  }

  const sideBarItems: WebNavigationItem[] = items.map((item) => ({
    ...item,
    href: item.href,
  }))

  return <WebNavigation items={sideBarItems} appVersion={appVersionString} />
}

export { Navigation }
